'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _makeCustomProvider = require('../../../../utils/reactRedux/makeCustomProvider');

var _makeCustomProvider2 = _interopRequireDefault(_makeCustomProvider);

var _editorConstants = require('../editorConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Utils
exports.default = (0, _makeCustomProvider2.default)(_editorConstants.EDITOR_STORE_NAME);

// Constants


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/store/components/EditorStoreProvider.js
// module id = 1747
// module chunks = 0